import {Component, inject} from '@angular/core';

import {PerspectiveFacade} from '@selpia/perspective/data-access';
import {SwitchInputComponent} from '@selpia/shared/ui';
import {NavigationService} from '@selpia/data-batch/history-access';

@Component({
  selector: 'lib-feature-include-total',
  templateUrl: './feature-include-total.component.html',
  styleUrl: './feature-include-total.component.scss',
  imports: [SwitchInputComponent],
})
export class FeatureIncludeTotalComponent {
  protected readonly perspectiveFacade = inject(PerspectiveFacade);
  readonly #navigationService = inject(NavigationService);

  handleClick(): void {
    const perspective = this.perspectiveFacade.perspective();
    if (perspective) {
      this.#navigationService.updatePerspective({includeTotal: !perspective.includeTotal});
    }
  }
}
